import React from "react";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";

const Footer = () => {
	return (
		<footer className="bg-gray-900 text-white py-12">
			<div className="container mx-auto px-4">
				<div className="w-full flex justify-center flex-row">
					<div className="grid grid-cols-1 md:grid-cols-4 gap-8">
						<div>
							<h3 className="text-xl font-bold mb-4">ighota!</h3>
							<p className="text-gray-400">
								Empowering West African students with quality
								educational resources.
							</p>
						</div>
						<div>
							<h4 className="font-semibold mb-4">Quick Links</h4>
							<ul className="space-y-2">
								<li>
									<Link
										to="/about"
										className="text-gray-400 hover:text-white transition-colors">
										About Us
									</Link>
								</li>
								<li>
									<Link
										to="/courses"
										className="text-gray-400 hover:text-white transition-colors">
										Courses
									</Link>
								</li>
								<li>
									<Link
										to="/mission"
										className="text-gray-400 hover:text-white transition-colors">
										Our Mission
									</Link>
								</li>
								<li>
									<Link
										to="/contact"
										className="text-gray-400 hover:text-white transition-colors">
										Contact
									</Link>
								</li>
							</ul>
						</div>
					</div>
					{/* <div>
						<h4 className="font-semibold mb-4">Resources</h4>
						<ul className="space-y-2">
							<li>
								<Link
									to="/blog"
									className="text-gray-400 hover:text-white transition-colors">
									Blog
								</Link>
							</li>
							<li>
								<Link
									to="/faq"
									className="text-gray-400 hover:text-white transition-colors">
									FAQs
								</Link>
							</li>
							<li>
								<Link
									to="/support"
									className="text-gray-400 hover:text-white transition-colors">
									Support
								</Link>
							</li>
							<li>
								<Link
									to="/terms"
									className="text-gray-400 hover:text-white transition-colors">
									Terms of Service
								</Link>
							</li>
						</ul>
					</div> */}
					<div className="max-w-[400px] w-full">
						<h4 className="font-semibold mb-4">Connect With Us</h4>
						<div className="flex space-x-4">
							<Link
								to="#"
								className="text-gray-400 hover:text-white transition-colors">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
									className="w-5 h-5">
									<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
								</svg>
							</Link>
							<Link
								to="#"
								className="text-gray-400 hover:text-white transition-colors">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
									className="w-5 h-5">
									<rect
										x="2"
										y="2"
										width="20"
										height="20"
										rx="5"
										ry="5"></rect>
									<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
									<line
										x1="17.5"
										y1="6.5"
										x2="17.51"
										y2="6.5"></line>
								</svg>
							</Link>
							<Link
								to="#"
								className="text-gray-400 hover:text-white transition-colors">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
									className="w-5 h-5">
									<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
								</svg>
							</Link>
						</div>
						<div className="mt-4">
							<p className="text-gray-400">
								Subscribe to our newsletter
							</p>
							<div className="mt-2 flex">
								<input
									type="email"
									placeholder="Your email"
									className="px-3 py-2 bg-gray-800 text-white rounded-l-md focus:outline-none focus:ring-1 focus:ring-yellow-500 w-full"
								/>
								<Button className="bg-yellow-500 h-full py-[10px] hover:bg-yellow-600 text-black rounded-l-none">
									Subscribe
								</Button>
							</div>
						</div>
					</div>
				</div>
				<div className="border-t border-gray-800 mt-10 pt-6 text-center text-gray-400">
					<p>©2024 Ighota - All Rights Reserved</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
